import React from "react";
import { HashRouter as Router, Route, Routes, Link } from "react-router-dom";
import Home from "./components/Home";
import Input from "./components/Input";
import InitialView from "./components/InitialView";
import Page2 from "./components/Page2";
import Page3 from "./components/Page3";
import Page4 from "./components/Page4";
import Completed from "./components/completed";
import Round from "./components/Round";
import Page5 from "./components/Page5";
import Page6 from "./components/Page6";
import Verify from "./components/Verify";
import MixColumnsView from "./components/MixColumnsView";
function App() {
  return (
    <Router>
      <div>
        <nav>
          <ul>
            <li>
              <Link to="/"></Link>
            </li>
          </ul>
        </nav>

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/input" element={<Input />} />
          <Route path="/initial" element={<InitialView />} />
          <Route path="/page2" element={<Page2 />} />
          <Route path="/page3" element={<Page3 />} />
          <Route path="/page4" element={<Page4 />} />
          <Route path="/round" element={<Round />} />
          <Route path="/page5" element={<Page5 />} />
          <Route path="/page6" element={<Page6 />} />
          <Route path="/verify" element={<Verify />} />
          <Route path="/completed" element={<Completed />} />
          <Route path="/MixColumnsView" element={<MixColumnsView />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
